/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from 'react';
import 'moment/locale/pt';

import ReactExport from "react-export-excel";
import { Box, Button, Typography } from '@mui/material';
import CustomizedTables from '../../../components/Table';
import FixedContainer from '../../../components/Container';
import LoadingComponent from '../../../components/LoadingComponent';
import { redirect, useNavigate } from 'react-router-dom';
import { GetFetch, urls } from '../../../services/apiBase';
import { useAppStatus } from '../../../hooks/app';


const Antecipacoes = () => {
  
  const [cprs, setCprs] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  
  const navigate = useNavigate()
  const { getCprSummarization } = useAppStatus();

  const COLUMNSTABLE = [
    {
      headerName: 'Identificação',
      type: 'default',
      value: {
        first: {
          parent: ['shared_personne'],
          value: 'name'
        },
        second: {
          value: 'nova_futura_id'
        }
      },
      noData: 'Não informado'
    },
    {
      headerName: 'N. da CPR',
      type: 'default',
      value: {
        first: {
          value: 'cpr_number'
        }
      }
    },
    {
      headerName: 'Data de ativação',
      type: 'date',
      value: {
        first: {
          value: 'date_signed'
        }
      }
    },
    {
      headerName: 'Data final',
      type: 'date',
      value: {
        first: {
          value: 'date_end'
        }
      }
    },
    {
      headerName: 'Data de atencipação',
      type: 'date',
      value: {
        first: {
          value: 'anticipate_date'
        }
      }
    },
    {
      headerName: 'Valor investido',
      type: 'money',
      value: {
        first: {
          value: 'amount_cpr'
        }
      }
    },
    {
      headerName: 'Taxa',
      type: 'percent',
      value: {
        first: {
          value: 'rate_cpr'
        }
      }
    },
    {
      headerName: 'Status pendente',
      type: 'default',
      value: {
        first: {
          parent: ['flowType', 'event_flows'],
          value: 'flow_description'
        }
      },
      noData: 'Não informado'
    },
    {
      headerName: 'Status',
      type: 'default',
      value: {
        first: {
          value: 'status'
        }
      }
    },
    {
      headerName: 'Tipo',
      type: 'default',
      value: {
        first: {
          value: 'type'
        }
      }
    },
  ]

  const getCPR = useCallback(async () => {
    setLoading(true)
    try {

      const response = await GetFetch(urls.GET_CPR_ATENCIPACAO_PROGRAMADA);

      if (!response.data.error) {
        const ordered = response.data.sort((a, b) => a.cpr_number < b.cpr_number ? 1 : -1);

        // CREATE ANTICIPATE DATE ATTRIBUTE ON CPR BASED ON CPR YIELDS
        ordered.map((cpr) => {
          const yields = cpr.cprs_yield;
          yields.sort((a, b) => a.current_installment < b.current_installment ? 1 : -1);
          let yieldIdx = 0;
          for (let i = 0; i < yields.length; i++) {
            const cyield = yields[i];
            if (cyield.status === 'ativa') {
              yieldIdx = i;
            }
          }
          cpr.anticipate_date = yields[yieldIdx].date_end;
        });

        setCprs(ordered);
      } else {
        setCprs(null)
      }
      setError(false)

    } catch (error) {
      console.log(error)
      setError(true)
    } finally {
      setLoading(false);
    }
  }, []);

  const handleOpenDetails = (cpr) => {
    return navigate('/cprf/details', { state: { cpr: cpr } })
  }

 
  const errorMessage = () => {
    return (
      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'center'
      }}>
        <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '24px', paddingBottom: 2, color: 'red' }}>
          Ocorreu um erro ao buscar os cupons
        </Typography>
      </Box>
    )
  }

  useEffect(() => {
    getCPR();
  }, [getCPR]);

  useEffect(() => {
    getCprSummarization();
  }, []);

  return (
    <FixedContainer>
      <Box sx={{
        width: '100%',
        height: '100%',
        backgroundColor: '#F9FBFD',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        boxShadow: 3,
        borderRadius: '10px',
        padding: 2,
      }}>
        {loading ? <LoadingComponent /> :
          error ? errorMessage() :
          cprs === null ? 
            <Box sx={{
              display: 'flex',
              width: '100%',
              justifyContent: 'center'
            }}>
              <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 2 }}>
                No momento não há CPRS com antecipações programadas
              </Typography>
            </Box>
            :
            <>
              <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 1 }}>
                CPRF's/Atencipações
              </Typography>

              <Box>
                <CustomizedTables
                  data={cprs}
                  columns={COLUMNSTABLE}
                  options
                  action={handleOpenDetails}
                />
              </Box>
            </>
        }
      </Box>
    </FixedContainer>
  );
}

export default Antecipacoes;
